import {Base} from "../Base";
import {arrayLast, findScrollParent, getUUID, isVisible, nnTrim, prefixUrl} from "../util";
import 'driver.js/dist/driver.css';
import {driver} from 'driver.js';
import {FetcherFactory} from "../fetch/Fetcher";

export class HelpElement extends Base {

    constructor(code, xOffset = 5, yOffset = -5, anchor = undefined) {
        super();
        this.code = code;
        this.xOffset = xOffset;
        this.yOffset = yOffset;
        this.anchor = anchor;
        this.id = getUUID();
        this.enabled = false;
    }

    getClassName() {
        return "HelpElement";
    }

    /**
     * log stat entry for this HelpElement
     * @param action {string}
     * @param store {boolean} if true, stores immediately
     */
    logStat(action, store = false) {
        if (tumbo && tumbo.STATS)
            tumbo.STATS.log(this, action, store);
    }

    /**
     * An ID token to use for logging
     * @return {string}
     */
    getLogId() {
        return nnTrim(this.getClassName(), this.getClass()) + " [" + this.getCode() + "]";
    }

    setAnchor(anchor) {
        this.anchor = anchor;
        return this;
    }

    getAnchor() {
        return this.anchor;
    }

    getElement() {
        if (!this.element) {
            this.element = $('<button>')
                .attr('id', this.id)
                .addClass('contextual-help')
                .addClass(this.code)
                .css('right', 'unset')
                .css('bottom', 'unset');
        }
        return this.element;
    }

    add2DOM() {
        if(!this.isAdded2DOM()) {
            $('body .tumbo-target').append(this.getElement());
            this.getElement().click(() => {
                this.logStat("OPEN");
                this.openPopup();
            });
            UIElement.allHelpElementsInDOM.push(this);
            this.added2DOM = true;
        }
        return this;
    }

    removeFromDOM(){
        if(this.isAdded2DOM()) {
            this.getElement().remove();
            UIElement.allHelpElementsInDOM.splice(UIElement.allHelpElementsInDOM.indexOf(this),1);
            this.added2DOM = false;
        }
    }

    isAdded2DOM(){
        return this.added2DOM;
    }

    openPopup() {
        if (this.enabled) {
            UIElement.allHelpElements.forEach(he => he.closePopup());
            this.getElement().addClass('open');
            this.driverObj = driver({
                allowClose: true,
                onDestroyStarted: () => {
                    this._onClosePopup();
                    this.driverObj.destroy();
                    this.driverObj = undefined;
                }
            });
            this.driverObj.highlight({
                element: this._getAnchorElem()[0],
                popover: {
                    allowClose: true,
                    showButtons: [
                        'close'
                    ],
                    onPopoverRender: (popover, {config, state}) => {
                        popover.footerButtons.innerHTML = "";
                        if(UIElement.helpContents[this.code].show_help) {
                            const moreButton = document.createElement("button");
                            moreButton.innerText = tumbo.translator.translate("help.contextual.more");
                            popover.footerButtons.appendChild(moreButton);
                            moreButton.addEventListener("click", () => {
                                this.logStat("GO_TO_HELPPAGE");
                                window.open(prefixUrl("/data/help-topics?appCode={0}#{1}".format([tumbo.code, this.code])), '_blank').focus();
                            });
                        }
                    },
                    onCloseClick: () => {
                        this.logStat("CLOSE");
                        this.closePopup()
                    },
                    title: nnTrim(UIElement.helpContents[this.code].title),
                    description: nnTrim(UIElement.helpContents[this.code].short_text),
                }
            });
            UIElement.contextualHelpPopupOpen = true;
        }
        return this;
    }

    _onClosePopup() {
        this.getElement().removeClass('open');
        UIElement.contextualHelpPopupOpen = false;
    }

    closePopup() {
        if (this.driverObj) {
            this.driverObj.destroy();
            this._onClosePopup();
        }
        return this;
    }

    updatePosition() {
        if (this.enabled) {
            if (!this.isAnchorVisible()) {
                this.getElement().addClass('hidden');
                return false;
            } else {
                const anchor = this._getAnchorElem();
                const anchorParent = this._getAnchorParentElem();
                const anchorRect = anchor[0].getBoundingClientRect();
                const anchorParentRect = anchorParent[0]?.getBoundingClientRect();
                const hasParent = !!anchorParentRect;
                const calculatedLeft = anchorRect.left + this.xOffset;
                const calculatedTop = anchorRect.top + this.yOffset;

                const newLeft = (hasParent
                    ? Math.min(anchorParentRect.right, Math.max(anchorParentRect.left, calculatedLeft))
                    : calculatedLeft).round(0);
                const newTop = (hasParent
                    ? Math.min(anchorParentRect.bottom, Math.max(anchorParentRect.top, calculatedTop))
                    : calculatedTop).round(0);

                const currentLeft = Number(this.element.css('left')?.split('px')[0]).round(0);
                const currentTop = Number(this.element.css('top')?.split('px')[0]).round(0);

                const element = this.getElement().removeClass('hidden');
                if(currentLeft!==newLeft || currentTop!==newTop){
                    element.css('left', newLeft + 'px').css('top', newTop + 'px');
                    return true;
                } else return false;
            }
        }
        return false;
    }

    isAnchorVisible() {
        return isVisible(this._getAnchorElem(), this.getCode()==='TOOL_identify_INDICATORS');
    }

    _getAnchorElem() {
        return this.anchor instanceof UIElement ? this.anchor.getUIElement() : this.anchor;
    }

    _getAnchorParentElem() {
        if (!this.achorParentElem || !this.achorParentElem[0]) {
            this.achorParentElem = $(findScrollParent(this._getAnchorElem()));
        }
        return this.achorParentElem;
    }

    getCode() {
        return this.code;
    }

    getId() {
        return this.id;
    }

    enable() {
        if (UIElement.helpContents[this.code]) {
            this.enabled = true;
            this.getElement().addClass('enabled').attr('title', tumbo.translator.translate('help.contextual.iconLabel', [UIElement.helpContents[this.code].title]));
            this.add2DOM();
        }
        return this;
    }

    isEnabled(){
        return this.enabled;
    }

    disable() {
        this.enabled = false;
        this.getElement().removeClass('enabled');
        this.removeFromDOM();
        return this;
    }

    destroy() {
        this.closePopup().disable();
        return this;
    }
}

/**
 * Any user interface element
 */
export class UIElement extends Base {

    static openUIElements = [];
    static escKeyInitialized = false;

    static allUIElements = [];
    static allUIElementsByID = {};

    static contextualHelpEnabled = false;
    static allHelpElements = [];
    static allHelpElementsInDOM = [];
    static helpContents = {}
    static contextualHelpPopupOpen = false;

    static observer = undefined;
    static mutationObserverCallback = mutations => {
        mutations.forEach(function (mutation) {
            if (mutation.addedNodes && mutation.addedNodes.length > 0) {
                // element added to DOM
                const ids = new Set();
                mutation.addedNodes.forEach((node) => {
                    const id = nnTrim(node.id);
                    if (id && UIElement.allUIElementsByID[id])
                        ids.add(id);
                })
                ids.forEach(id => UIElement.allUIElementsByID[id].add2DOM());
            }
        });
    };

    static add2AllUIElements(uiElement) {
        UIElement.allUIElements.push(uiElement);
        if (uiElement.getId())
            UIElement.allUIElementsByID[uiElement.getId()] = uiElement;
        if (UIElement.contextualHelpEnabled) {
            UIElement.allUIElements.forEach(e => e.enableContextualHelpButtons());
        }
    }

    static enableContextualHelp() {
        UIElement.contextualHelpEnabled = true;
        UIElement.allUIElements.forEach(e => e.enableContextualHelpButtons());
        UIElement.helpIconsTracker = (runAgainInMillis=50) => {
            if(UIElement.contextualHelpEnabled) {
                if (UIElement.updateHelpIconsPositionTimeout || !UIElement.contextualHelpEnabled)
                    clearTimeout(UIElement.updateHelpIconsPositionTimeout);
                UIElement.updateHelpIconsPositionTimeout = setTimeout(() => {
                    if (UIElement.contextualHelpEnabled) {
                        const changed = UIElement.allHelpElementsInDOM
                            .filter(e => e.isEnabled())
                            .map(e =>  e.updatePosition())
                            .filter(changed => changed).length > 0;
                        requestAnimationFrame(()=>UIElement.helpIconsTracker(Math.max(5, Math.min(200, runAgainInMillis + (changed ? -200 : 50)))));
                    }
                }, runAgainInMillis);
            }
        };
        requestAnimationFrame(()=>UIElement.helpIconsTracker());
    }

    static disableContextualHelp() {
        UIElement.contextualHelpEnabled = false;
        UIElement.allUIElements.forEach(e => e.disableContextualHelpButtons());
    }

    /**
     * @param id {string} Unique id of this UI element
     * @param onChangeRuntimeConfig {function} A callback to be called when runtimeConfig is changed
     */
    constructor(id, onChangeRuntimeConfig) {
        super();
        this.fetcherFactory = new FetcherFactory();
        this.onChangeRuntimeConfig = onChangeRuntimeConfig;
        this.id = id;
        this.onAdd2DOMCallbacks = new Set();
        this.helpElements = [];

        if (!UIElement.escKeyInitialized) {
            $('body').keyup(function (e) {
                if (UIElement.contextualHelpPopupOpen)
                    return;
                if (e.key === "Escape" && UIElement.openUIElements.length > 0) {
                    arrayLast(UIElement.openUIElements).close();
                }
            });
            UIElement.escKeyInitialized = true;
        }

        UIElement.add2AllUIElements(this);

        if (!UIElement.observer) {
            UIElement.observer = new MutationObserver(UIElement.mutationObserverCallback);
            UIElement.observer.observe(document.body, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
    }

    setFetcherFactory(fetcherFactory){
        this.fetcherFactory = fetcherFactory;
        return this;
    }

    addHelpElement(helpElement) {
        this.removeHelpElement(helpElement.getId());
        if (!helpElement.getAnchor())
            helpElement.setAnchor(this);
        this.helpElements.push(helpElement);
        UIElement.allHelpElements.push(helpElement);
        if (UIElement.contextualHelpEnabled)
            helpElement.enable();
        return this;
    }

    removeHelpElement(id) {
        const toRemove = this.helpElements.filter(he => he.getId() === id)[0];
        if (toRemove) {
            $('body').remove('#' + id);
            toRemove.destroy();
            this.helpElements = this.helpElements.filter(he => he.getId() !== id);
        }
        return this;
    }

    enableContextualHelpButtons() {
        this.helpElements.forEach(e => e.enable());
        return this;
    }

    disableContextualHelpButtons() {
        this.helpElements.forEach(e => e.disable());
        return this;
    }

    getClassName() {
        return "UIElement";
    }

    /**
     * UI element code
     * @returns {string}
     */
    getCode() {
        return this.getId() ? this.getId() : 'NOCODE';
    }

    getCodeHtmlClass() {
        return this.getCode()
            .replaceAll(".", "_")
            .replaceAll("#", "_");
    }

    /**
     * The element to be added to DOM
     * @return {jQuery}
     */
    getUIElement() {
    }

    /**
     * When the given element is focus-visible, detect space or enter key up and run given callback
     * A second call to this method will add a new callback to the given elem
     * @param callback {function}
     * @param elem {jQuery|undefined} The element to detect focus-visible on. if undefined, uses this.getUIElement()
     */
    onFocusedEnterOrSpace(callback, elem = undefined) {
        elem = elem ? elem : this.getUIElement();
        elem.on('keyup', event => {
            if (elem.is(":focus-visible")) {
                let keycode = (event.keyCode ? event.keyCode : event.which);
                if (keycode === 13 || keycode === 32) {
                    callback();
                }
            }
        })
    }

    /**
     * An ID token to use for logging
     * @return {string}
     */
    getLogId() {
        return nnTrim(this.getClassName(), this.getClass()) + " [" + this.getCode() + "]";
    }

    /**
     * This element id
     * @returns {string}
     */
    getId() {
        return this.id;
    }

    /**
     * log stat entry for this UIElement
     * @param action {string}
     * @param store {boolean} if true, stores immediately
     */
    logStat(action, store = false) {
        if (tumbo && tumbo.STATS)
            tumbo.STATS.log(this, action, store);
    }

    /**
     * This function sets values related to the UI size and position
     * @param isSmallContainerWidth {boolean} Is this a small width application container?
     * @param isSmallContainerHeight {boolean} Is this a small height application container?
     * @param width {number} The with of the container in pixels (integer)
     * @param height {number} The height of the container in pixels (integer)
     * @param containerAbsolutePosition {Object} the absolute position of the container {top:, left:}
     */
    setContainerSizeAndPosition(isSmallContainerWidth, isSmallContainerHeight, width, height, containerAbsolutePosition) {
        const changed = this.isSmallContainerWidth !== isSmallContainerWidth || this.isSmallContainerHeight !== isSmallContainerHeight;
        this.isSmallContainerWidth = isSmallContainerWidth;
        this.isSmallContainerHeight = isSmallContainerHeight;
        this.containerWidth = width;
        this.containerHeight = height;
        this.containerAbsolutePosition = containerAbsolutePosition;
        if (changed) {
            this.onSmallContainer();
        }
        this.helpElements.forEach(e => e.updatePosition());
    }

    /**
     * This function is called whenever the container size changes enough to be considered small or not small
     * Should be redefined by subclasses to react to the change
     */
    onSmallContainer() {
    }

    /**
     * Is a value defined for the given key
     * @param prop {string} A property key
     * @return {*}
     */
    hasSessionProp(prop) {
        return tumbo.runtimeConfig.hasUIElementSessionProp(this.getId(), prop);
    }

    /**
     * Get a value by property key
     * @param prop {string} A property key
     * @param defValue {*}
     * @return {*}
     */
    getSessionProp(prop, defValue = undefined) {
        const val = tumbo.runtimeConfig?.getUIElementSessionProp(this.getId(), prop);
        return val !== undefined && val !== null ? val : defValue;
    }

    /**
     * Set a property value that lasts for this session (ends on close tab)
     * @param prop {string} A property key
     * @param value {*} any value
     * @return {UIElement} This UIElement
     */
    setSessionProp(prop, value) {
        tumbo.runtimeConfig.setUIElementSessionProp(this.getId(), prop, value);
        return this;
    }

    /**
     * Remove a property
     * @param prop {string} A property key
     * @return {UIElement} This UIElement
     */
    removeSessionProp(prop) {
        tumbo.runtimeConfig.removeUIElementSessionProp(this.getId(), prop);
        return this;
    }

    /**
     * Close this UI element
     * Override when necessary
     * @return {UIElement} This UIElement
     *
     */
    close() {
        return this;
    }

    /**
     * Destroy this UI element and remove it from DOM
     * @return {UIElement} This UIElement
     */
    destroy() {
        this.close();
        this.helpElements.map(he => he.getId()).forEach(id => this.removeHelpElement(id));
        this.uiElement?.remove();
        return this;
    }

    /**
     * Add a callback for when the element is added to the DOM
     * @param callback {function}
     * @return {*<UIElement>}
     */
    onAdd2DOM(callback) {
        if (this.added2Dom || $('#' + this.id).length > 0) {
            callback();
            this.added2Dom = true;
        } else this.onAdd2DOMCallbacks.add(callback);
        return this;
    }

    /**
     * Call when an element has been added to the DOM
     * Use with caution, only when the holder of the DOM element is not a UIElement, otherwise use enableObservationUnderUIElement
     * @return {*.<UIElement>}
     */
    add2DOM() {
        if (!this.added2Dom)
            this.onAdd2DOMCallbacks.forEach(c => c());
        this.added2Dom = true;
        return this;
    }

    isAdded2DOM() {
        return this.added2Dom;
    }

    /**
     * Enables a MutationObserver under the element passed as param or the result of getUIElement if undefined
     * It will call onAdd2DOM on any UIElement added under this
     * @param elem {jQuery} the element to observe
     * @return {*.<UIElement>}
     */
    enableObservationUnderUIElement(elem = this.getUIElement()) {
        if (!this.observers)
            this.observers = {};
        if (!this.observers[elem[0]]) {
            this.observers[elem[0]] = new MutationObserver(UIElement.mutationObserverCallback);
            this.observers[elem[0]].observe(elem[0], {
                attributes: true,
                childList: true,
                characterData: true
            });
        }
        return this;
    }
}